export default "__VITE_ASSET__ncn5weXZ__"